export class PageConfig {
  public defaults: any = {
    dashboard: {
      page: {
        title: 'Dashboard',
        desc: 'Latest updates and statistic charts'
      },
    },
    "fileReturn": {
      "file-manage": {
        page: { title: 'Gerenciar Arquivos de Retorno', desc: '' }
      },
      "file-import": {
        page: { title: 'Importar Arquivo de Retorno', desc: '' }
      },
      "file-audit": {
        page: { title: 'Gerenciar Arquivo', desc: '' }
      }
    },
    "fileRemitance": {
      "management": {
        page: { title: 'Gerenciar Arquivos de Remessa', desc: '' }
      },
      "generate": {
        page: { title: 'Gerar Remessa de Cobrança Registrada', desc: '' }
      },
      "details": {
        page: { title: 'Detalhe de Arquivo de Remessa', desc: '' }
      }
    },
    "management": {
      "rounding": {
        page: { title: 'Arredondamentos', desc: '' }
      },
      "contract": {
        page: { title: 'Alteração de Contratos', desc: '' }
      }
    },
    "recurring-card": {
      "records": {
        page: { title: 'Cartão Recorrente', desc: '' }
      },
      "management": {
        page: { title: 'Gerenciamento de Recorrência', desc: '' }
      }
    },
    "tasks": {
      "manage-tasks": {
        page: { title: 'Tarefas Agendadas', desc: '' }
      }
    },
    "accounting": {
      "batch": {
        page: { title: 'Exportação de Lote', desc: '' }
      },
      "batch-details/:id": {
        page: { title: 'Detalhes do Lote', desc: '' }
      }
    },
    "agreement-external-collector": {
      "manage-agreement": {
        page: { title: 'Gerenciar Acertos', desc: '' }
      },
      "agreement-detail": {
        page: { title: 'Gerenciar Acertos - Detalhe', desc: '' }
      },
      "new": {
        page: { title: 'Criar Acerto', desc: '' }
      }
    },
    error: {
      404: {
        page: { title: '404 Not Found', desc: '', subheader: false }
      },
      403: {
        page: { title: '403 Access Forbidden', desc: '', subheader: false }
      }
    },
  };

  public get configs(): any {
    return this.defaults;
  }
}
